const getDisplayStatus = (status)=>{
    switch(status){
        case 'active':
            return 'Active';
        case 'pending':
            return 'Pending';
        default:
            return status;
    }
};
const getDisplayKnownTenantProvider = (provider)=>{
    switch(provider){
        case 'github':
            return 'GitHub';
        case 'hubspot':
            return 'HubSpot';
        case 'slack':
            return 'Slack';
    }
};
const getDisplayTenantProvider = (provider)=>{
    return getDisplayKnownTenantProvider(provider) || provider;
};

export { getDisplayKnownTenantProvider, getDisplayStatus, getDisplayTenantProvider };
//# sourceMappingURL=getDisplay.mjs.map
